import { useEffect, useState } from "react";
import { useDolfinClient, useDolfinAuth } from "@/components/DolfinProvider";

/**
 * Only "Registered" counts (the backend send plan's rule); the direct send buttons skip the plan. Null until known.
 * Pass `enabled` only once an e-invoicing module is held: GET /v1/e-invoicing 403s, and toasts, without one.
 */
export function useEInvoicingRegistered(enabled: boolean): boolean | null {
  const api = useDolfinClient();
  const { organisationId } = useDolfinAuth();
  const [registered, setRegistered] = useState<boolean | null>(null);

  useEffect(() => {
    setRegistered(null);
    if (!enabled || !organisationId) return;
    let cancelled = false;
    void api.GET("/v1/e-invoicing", {}).then(({ data }) => {
      if (!cancelled) setRegistered(data ? data.status === "Registered" : null);
    });
    return () => {
      cancelled = true;
    };
  }, [api, organisationId, enabled]);

  return registered;
}
